import Asset from "../components/Asset";
import Background from "../components/Background";
import ContentCenter from "../components/ContentCenter";
import { Flex } from "../components/Flex";
import Line from "../components/Line";
import Paragraph from "../components/Paragraph";
import { useAlbertineTranslation } from "../package/albertine-i18n";
import "./AlbertineLearnMore.css";

export default function AlbertineLearnMore() {
    const t = useAlbertineTranslation();
    return (
        <Background.BookingBg02>
            <ContentCenter.Large className="albertine__learn-more">
                <Flex.Column alignItems="center" gap="value24">
                    <Flex.Column alignItems="center" gap="value24">
                        <Asset.AlbertineLogo />
                    </Flex.Column>

                    <Flex.Column alignItems="center" gap="value24">
                        <Paragraph.Large.Reqular.Text1>
                            {t("public-learn-more__description")}
                        </Paragraph.Large.Reqular.Text1>
                        <Line.Vertical />
                        <a
                            href="https://www.albertineapp.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="web-lib__button-base web-lib__button-primary"
                        >
                            {t("public-learn-more__request")}
                        </a>
                    </Flex.Column>
                </Flex.Column>
            </ContentCenter.Large>
        </Background.BookingBg02>
    );
}
